import React from 'react';
import CreatePassword from '../Register/Local/CreatePasswordForm.js';
import VerifyCode from '../Code/VerifyCode.js';
import Loader from '../Loader.js';
import MfaTrustPage from '../Login/MfaTrustPage.js';
import navigateWithAnalytics from '../../analytics/navigateWithAnalytics.js';

class ResetPassword extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ...props,
            payload: null,
            code: null,
            username: null,
            signInType: "EMAIL",
            isResponseValid: false,
            showForm: "RESET",
            uid: null,
        };
        this.displayForm = this.displayForm.bind(this);
        this.savePayload = this.savePayload.bind(this);
        this.saveCode = this.saveCode.bind(this);
    }

    async startJourney() {
        this.setState({ isResponseValid: true });
    }

    componentDidMount() {
        const uid = sessionStorage.getItem("uid") || null;
        const username = sessionStorage.getItem("EMAIL") || null;
        const payloadStr = sessionStorage.getItem("RP_PAYLOAD");
        if (!sessionStorage.AP_SSID && !uid) {
            navigateWithAnalytics("/", "default-redirect", "auto");
        }
        let payload = null;
        if (payloadStr) {
            try {
                payload = JSON.parse(payloadStr);
            } catch (error) {
                console.error("Invalid payload format", error);
            }
        }
        this.setState({ uid, payload, username });
        sessionStorage.removeItem("uid");
        sessionStorage.removeItem("RP_PAYLOAD");
        sessionStorage.removeItem("EMAIL");
        this.startJourney();
    }

    saveCode(value) {
        this.setState({ code: value })
    }

    savePayload(value) {
        this.setState({ payload: value });
    }

    displayForm(value) {
        this.setState({ showForm: value });
    }

    render() {
        if (this.state.isResponseValid === false) {
            return (<Loader />)
        }
        return (
            <>
                {this.state.showForm === "RESET" &&
                    <VerifyCode
                        style={sessionStorage.AP_STYLE}
                        payload={this.state.payload}
                        showForm={this.state.showForm}
                        signInType={this.state.signInType}
                        savePayload={this.savePayload}
                        saveCode={this.saveCode}
                        displayForm={this.displayForm}
                        username={this.state.username}
                        uid={this.state.uid}
                    />
                }
                {this.state.showForm === "PASSWORD" &&
                    <CreatePassword
                        style={sessionStorage.AP_STYLE}
                        signInType={this.state.signInType}
                        payload={this.state.payload}
                        code={this.state.code}
                        displayForm={this.displayForm}
                        prevStep="RESET"
                        username={this.state.username}
                        uid={this.state.uid}
                        savePayload={this.savePayload}
                    />
                }
                {this.state.showForm === "TRUST" &&
                    <MfaTrustPage  
                        payload={this.state.payload} 
                        savePayload={this.savePayload}
                    />
                }
            </>
        )
    }
}

export default ResetPassword;